<template>
  <div class="container">
    <img :src="static_img_url + 'pic/pay-state.png?v=' + imgVersion" />
    <p class="p1">Payment result is being confirmed. </p>
    <p class="p2">Please do not close this page.</p>
  </div>
</template>
<script>
import { paypalCheckoutOrder } from '@/service/vbef'
import { mapState } from 'vuex'
export default {
  components: {},
  created() {
    this.paypalCheckoutOrder()
  },
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      imgVersion: (state) => state.imgVersion,
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    async paypalCheckoutOrder() {
      let res = await paypalCheckoutOrder({
        activityOrderNumber: this.$route.query.order,
      })
      if (res.code == 0 && res.data.status == 2) {
        if (this.isMobile) {
          this.$notify({
            type: 'success',
            message: 'Registration successful!',
          })
        } else {
          this.$Message.success('Registration successful!')
        }
        this.$router.push({
          name: 'ticketDetail',
          params: { id: res.data.activityTicketUserRelationId },
        })
      } else {
        if (this.isMobile) {
          this.$notify(res.enMsg || res.msg)
        } else {
          this.$Message.error(res.enMsg || res.msg)
        }
        this.$router.push({
          name: 'singUp',
        })
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.container
  padding-top 20vh
  display flex
  flex-direction column
  align-items center
  img
    width 250px
    height 135px
  .p1
    color #333
    font-size 16px
    line-height: 2
    margin-top: 20px
  .p2
    color #C8161D
    font-size 18px
    font-weight: 700
    line-height: 2
</style>